<div class="wrapper mat-elevation-z10">
    <div class="header">
        <span>
            <h1>Client to Client Journal</h1>
        </span>
        <div class="toggle">
            <span>C-C transfer</span>
        </div>
    </div>
    <div class="form-container">
        <form [formGroup]="journalRequestForm" #formDirective="ngForm" (ngSubmit)="submit(formDirective)">
            <div class="form">
                <div class="search">
                    <mat-form-field class="matterAuto">
                        <mat-label>Matter from</mat-label>
                        @if (journalRequestForm.controls['matterFrom'].value) {
                        <button type="button" (click)="clearSearchFilter('from')" mat-icon-button matSuffix>
                            <mat-icon>clear</mat-icon>
                        </button>
                        }
                        <input matInput
                               formControlName="matterFrom"
                               [matAutocomplete]="auto" />
                        @if (journalRequestForm.get('matterFrom')?.touched && journalRequestForm.get('matterFrom')?.hasError('required')) {
                        <mat-error>Please select a matter.</mat-error>
                        }
                    </mat-form-field>
                    <mat-autocomplete #auto="matAutocomplete">
                        @if (isLoading) {
                        <mat-option>Loading....</mat-option>
                        } @else if (noData) {
                        <mat-option>No matching matters found.</mat-option>
                        } @else {
                        @for (item of matterFromDropdownData; track item.number) {
                        <mat-option [value]="displayMatter(item)"
                                    (onSelectionChange)="lookupSelectionChanged($event, 'matterFrom')">
                            {{ item.number }} - {{ item.description }}
                        </mat-option>
                        }
                        }
                    </mat-autocomplete>

                    @if (showLinkToOpenMatter1()) {
                    <div class="sticky-actionstep-bar">
                        <div class="link-wrapper">
                            <a [href]="actionstepMatterUrl1"
                               target="_blank"
                               rel="noopener noreferrer">
                                Open Matter in Actionstep ({{ matterFromNo }})
                            </a>
                            <button type="button"
                                    mat-icon-button
                                    class="small-copy-btn"
                                    [cdkCopyToClipboard]="actionstepMatterUrl1"
                                    (cdkCopyToClipboardCopied)="onUrlCopied()"
                                    matTooltip="Copy link to clipboard"
                                    matTooltipPosition="below">
                                <mat-icon>content_copy</mat-icon>
                            </button>
                        </div>
                        <div class="warning-box">
                            You must be logged into Actionstep under the same jurisdiction.
                        </div>
                    </div>
                    }
                </div>

                <div class="search">
                    <mat-form-field class="matterAuto">
                        <mat-label>Matter to</mat-label>
                        @if (journalRequestForm.controls['matterTo'].value) {
                        <button type="button" (click)="clearSearchFilter('to')" mat-icon-button matSuffix>
                            <mat-icon>clear</mat-icon>
                        </button>
                        }
                        <input matInput
                               formControlName="matterTo"
                               [matAutocomplete]="autoTo"
                               (beforeinput)="$event.preventDefault()"
                               class="readonly-select-input" />
                        @if (journalRequestForm.get('matterTo')?.touched && journalRequestForm.get('matterTo')?.hasError('required')) {
                        <mat-error>Please select a matter.</mat-error>
                        }
                        @if (!journalRequestForm.controls['matterTo'].hasError('required') && journalRequestForm.controls['matterTo'].hasError('sameMatter')) {
                        <mat-error>Source and destination matters must be different.</mat-error>
                        }
                    </mat-form-field>
                    <mat-autocomplete #autoTo="matAutocomplete">
                        @if (isMatterToLoading) {
                        <mat-option disabled>Loading....</mat-option>
                        } @else if (!matterToDropdownData.length) {
                        <mat-option disabled>No matters available for the selected Matter From client.</mat-option>
                        } @else {
                        @for (item of matterToDropdownData; track item.number) {
                        <mat-option [value]="displayMatter(item)"
                                    (onSelectionChange)="lookupSelectionChanged($event, 'matterTo')">
                            {{ item.number }} - {{ item.description }}
                        </mat-option>
                        }
                        }
                    </mat-autocomplete>

                    @if (showLinkToOpenMatter2()) {
                    <div class="sticky-actionstep-bar">
                        <div class="link-wrapper">
                            <a [href]="actionstepMatterUrl2"
                               target="_blank"
                               rel="noopener noreferrer">
                                Open Matter in Actionstep ({{ matterToNo }})
                            </a>
                            <button type="button"
                                    mat-icon-button
                                    class="small-copy-btn"
                                    [cdkCopyToClipboard]="actionstepMatterUrl2"
                                    (cdkCopyToClipboardCopied)="onUrlCopied()"
                                    matTooltip="Copy link to clipboard"
                                    matTooltipPosition="below">
                                <mat-icon>content_copy</mat-icon>
                            </button>
                        </div>
                        <div class="warning-box">
                            You must be logged into Actionstep under the same jurisdiction.
                        </div>
                    </div>
                    }
                </div>

                <div class="search">
                    <mat-form-field appearance="outline" class="w-100">
                        <mat-label>Client Bank (From)</mat-label>
                        <mat-select formControlName="clientBankAccount1" required>
                            @for (account of filteredBankAccounts; track account.id) {
                            <mat-option [value]="account">
                                {{ account.accountId }} - {{ account.description }}
                            </mat-option>
                            }
                        </mat-select>
                        @if (journalRequestForm.get('clientBankAccount1')?.hasError('required')) {
                        <mat-error>Please select a bank account.</mat-error>
                        }
                    </mat-form-field>

                    @if (showLinkToOpenMatter1()) {
                    <div class="actionstep-matter-overview">
                        <div class="link-wrapper">
                            <a [href]="actionstepMatterOverviewUrl1"
                               target="_blank"
                               rel="noopener noreferrer">
                                Open Actionstep Matter ({{ matterFromNo }}) Overview
                            </a>
                            <button type="button"
                                    mat-icon-button
                                    class="small-copy-btn"
                                    [cdkCopyToClipboard]="actionstepMatterOverviewUrl1"
                                    (cdkCopyToClipboardCopied)="onUrlCopied()"
                                    matTooltip="Copy link to clipboard"
                                    matTooltipPosition="below">
                                <mat-icon>content_copy</mat-icon>
                            </button>
                        </div>
                        <div class="warning-box">
                            You must be logged into Actionstep under the same jurisdiction.
                        </div>
                    </div>
                    }
                </div>

                <div class="search">
                    <mat-form-field appearance="outline" class="w-100">
                        <mat-label>Client Bank (To)</mat-label>
                        <mat-select formControlName="clientBankAccount2" required>
                            @for (account of filteredBankAccounts; track account.id) {
                            <mat-option [value]="account">
                                {{ account.accountId }} - {{ account.description }}
                            </mat-option>
                            }
                        </mat-select>
                        @if (journalRequestForm.get('clientBankAccount2')?.hasError('required')) {
                        <mat-error>Please select a bank account.</mat-error>
                        }
                    </mat-form-field>

                    @if (showLinkToOpenMatter2()) {
                    <div class="actionstep-matter-overview">
                        <div class="link-wrapper">
                            <a [href]="actionstepMatterOverviewUrl2"
                               target="_blank"
                               rel="noopener noreferrer">
                                Open Actionstep Matter ({{ matterToNo }}) Overview
                            </a>
                            <button type="button"
                                    mat-icon-button
                                    class="small-copy-btn"
                                    [cdkCopyToClipboard]="actionstepMatterOverviewUrl2"
                                    (cdkCopyToClipboardCopied)="onUrlCopied()"
                                    matTooltip="Copy link to clipboard"
                                    matTooltipPosition="below">
                                <mat-icon>content_copy</mat-icon>
                            </button>
                        </div>
                        <div class="warning-box">
                            You must be logged into Actionstep under the same jurisdiction.
                        </div>
                    </div>
                    }
                </div>

                <mat-form-field>
                    <mat-label>Reason for transfer</mat-label>
                    <input matInput formControlName="reason" />
                    <mat-error>Please enter a valid reason for transfer.</mat-error>
                </mat-form-field>

                <mat-form-field>
                    <mat-label>Amount</mat-label>
                    <input type="text" matInput maxlength="12" formControlName="amount"
                           (keydown)="validateInput($event)" [value]="displayValue" (blur)="formatNumber()" />
                    <mat-error>Please enter a valid amount.</mat-error>
                </mat-form-field>

                @if (isUserPartner === false) {
                <div class="fullLength">
                    <mat-form-field>
                        <mat-label>Partner authorising</mat-label>
                        <mat-select formControlName="partnerAuthorisingId">
                            @for (partner of partnerList; track partner.id) {
                            <mat-option [value]="partner.id">
                                {{ partner.name }}
                            </mat-option>
                            }
                        </mat-select>
                        @if (journalRequestForm.get('partnerAuthorisingId')?.hasError('required')) {
                        <mat-error>Partner authorising is required.</mat-error>
                        }
                    </mat-form-field>
                </div>
                }

                <xp-draft-documents class="fullLength"
                                    [documents]="draftEditor.documents()"
                                    (remove)="draftEditor.removeDocument($event)" />

                <mat-form-field class="fullLength">
                    <mat-label>Files to upload</mat-label>
                    <input matInput [value]="displayFile.join(', ')" placeholder="Please select a file" readonly>
                    <button type="button" (click)="fileInput.click()" mat-icon-button matSuffix>
                        <mat-icon>upload_file</mat-icon>
                    </button>
                    @if (displayFile.length > 0) {
                    <button type="button" (click)="clearUpload()" mat-icon-button matSuffix>
                        <mat-icon>clear</mat-icon>
                    </button>
                    }
                    <input type="file" id="fileInput" (change)="onFilesSelected($event.target)" #fileInput multiple hidden>
                </mat-form-field>

                <div class="date-time-row">
                    <mat-form-field color="accent" class="date-field">
                        <mat-label>Requested Date</mat-label>
                        <input matInput [matDatepicker]="requestedDatePicker" formControlName="dateRequested" placeholder="dd/MM/yyyy" [max]="currentDate"/>
                        <mat-datepicker-toggle matSuffix [for]="requestedDatePicker" />
                        <mat-datepicker #requestedDatePicker />
                        @if (journalRequestForm.get('dateRequested')?.touched && journalRequestForm.get('dateRequested')?.invalid) {
                        <mat-error>Please select a date.</mat-error>
                        }
                    </mat-form-field>

                    <mat-form-field color="accent" class="time-field">
                        <mat-label>Requested Time</mat-label>
                        <input matInput type="time" formControlName="requestedTime" placeholder="HH:mm" />
                        @if (journalRequestForm.get('requestedTime')?.touched && journalRequestForm.get('requestedTime')?.invalid) {
                        <mat-error>Please enter a time.</mat-error>
                        }
                    </mat-form-field>
                </div>
            </div>


            @if (isUserPartner) {
            <mat-checkbox class="fullLength" formControlName="fundsCheckedByPartner">
                I confirm that available funds have been checked.<span class="important">*</span>
            </mat-checkbox>
            }

            <div class="action-button">
                <xp-draft-actions [draftName]="draftEditor.draftName()"
                                  [busy]="draftEditor.saving()"
                                  [disabled]="!canSaveDraft || submitBtn"
                                  (saveDraft)="saveDraftAndReset(formDirective)" />
                <button color="accent"
                        [disabled]="submitBtn || draftEditor.saving() || journalRequestForm.invalid || journalRequestForm.untouched"
                        class="mat-accent submit-btn"
                        type="submit"
                        mat-raised-button>
                    {{ isUserPartner ? 'Submit For Account Approval' : 'Submit For Partner Approval' }}
                </button>
            </div>
        </form>
    </div>
</div>
